import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import { ClienteItemResponse } from "core/features/cliente/typings";
import TagStatus from "./components/TagStatus";
import { GoAlert } from "react-icons/go";
import { formatCNPJ, formatCPF } from "@brazilian-utils/brazilian-utils";

function useClientesColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome",
        width: "350px",
        render: (original: ClienteItemResponse) => <Flex>{original.nome}</Flex>,
      },
      {
        title: "CPF/CNPJ",
        width: "200px",
        render: (original: ClienteItemResponse) => (
          <Flex>
            {original?.documento?.length > 11
              ? formatCNPJ(original.documento)
              : formatCPF(original.documento)}
          </Flex>
        ),
      },
      {
        render: (original: ClienteItemResponse) => (
          <Flex gap={4}>
            {original.inadimplente ? (
              <TagStatus
                colorScheme="red"
                title="Inadimplente"
                icon={<GoAlert />}
              />
            ) : null}

            {original.tempoFimContrato ? (
              <TagStatus
                colorScheme="gray"
                title={`${original.tempoFimContrato}
                ${original.tempoFimContrato === 1 ? " dia " : " dias "}
                do fim do contrato `}
              />
            ) : null}

            {original.novo ? (
              <TagStatus colorScheme="green" title="Novo cliente" />
            ) : null}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useClientesColumns;
